import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchTruckDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import DriverMaster from "./DriverMaster";
import CtART from "./CustomTool/ResponsiveTable";

class TruckMaster extends Component {
  state = {
    formData: {
      bint_srno: "",
      txttruckno: "",
      txtNoWheels: "",
      txtRemark: "",
    },
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: " Sr No.",
      },
      {
        accessorKey: "vac_truckno",
        header: " Truck No.",
        size: 5,
      },
      {
        accessorKey: "int_noofwheels",
        header: "No. Wheels",
        size: 5,
      },
      {
        accessorKey: "vac_remark",
        header: "Remark",
      },
    ],
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    columnsOtherDetail: [
      { id: "Action", label: "" },
      {
        id: "vac_value",
        label: "Driver",
        type: "CtCmb",
        CtrlProps: {
          items: ["Lalji", "Samji"],
          width: 250,
          maxLength: 20,
        },
      },
    ],
    rowsOtherDetail: [],
    rowsCountOtherDetail: 0,
    rowsPerPageOtherDetail: 10,
    dataLoadStatus: true,
    ARD: null,
  };

  componentDidMount() {
    {
      !this.props.showHeading && (document.title = "RA : Truck Master");
    }
    this.props.setActiveMenu("TruckMaster");
    console.log("this.props.setUserPrivileges", this.props.setUserPrivileges);
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      Truck = row.getValue("vac_truckno");
    // NoWheels = row.getValue("int_noofwheels");
    // Remark = row.getValue("vac_remark");
    // this.DeleteData(bint_srno, Truck, NoWheels, Remark);
    this.DeleteData(bint_srno, Truck);
  };

  DeleteData = (bint_srno, Truck) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Truck NO. : " + Truck + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteTruck(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteTruck = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteTruck",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      // bol_list: true,
    };
    fetchTruckDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.TruckList && res.data.TruckList.length > 0) {
            rows = res.data.TruckList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txttruckno").focus();
        }
      })
      // fetchTruckDetail(reqData)
      //   .then((res) => {
      //     this.props.updateProcessing(res.data.msgType, res.data.message);
      //     if (res.data.msgType === "success") {
      //       const rows = res.data.TruckList || [];
      //       this.setState({
      //         rows,
      //         rowsCount: rows.length,
      //         ARD: null,
      //       });
      //       this.onFormLoad();
      //       this.clearInfo();
      //     }
      //   })

      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          maxWidthClass={"xl"}
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<DriverMaster />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPage = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnRowDataChange = (rowsOtherDetail) => {
    this.setState({
      rowsOtherDetail,
      rowsCountOtherDetail: rowsOtherDetail.length,
    });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      // excludeKeysArray: [""],
      numberKeysArray: ["txtNoWheels"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadTruck",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchTruckDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.TruckList && res.data.TruckList.length > 0) {
            rows = res.data.TruckList;
            rowsCount = rows.length;
          }
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txttruckno").focus();
  };

  clearInfo = () => {
    let bint_srno = "",
      txttruckno = "",
      txtNoWheels = "",
      txtRemark = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txttruckno,
          txtNoWheels,
          txtRemark,
        },
      },
      () => {
        document.getElementById("txttruckno").focus();
      }
    );
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    // const bint_srno = row.getValue("bint_srno"),
    //   txttruckno = row.getValue("vac_truckno"),
    //   txtNoWheels = row.getValue("int_noofwheels"),
    //   txtRemark = row.getValue("vac_remark");
    // // const rows2 = row.original.CheckToDoList;
    // // console.log("rows2", rows2);

    const bint_srno = row.getValue("bint_srno"),
      txttruckno = row.getValue("vac_truckno"),
      txtNoWheels = row.getValue("int_noofwheels"),
      // txtNoWheels = row.getValue("int_noofwheels") ? String(row.getValue("int_noofwheels")) : "", // Convert to string
      txtRemark = row.getValue("vac_remark");

    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txttruckno,
        txtNoWheels,
        txtRemark,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txttruckno").focus();
  };

  SaveTruck = () => {
    this.trimFormData(() => {
      if (this.validatTruckMaster()) {
        let dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus: false }, () => {
          const reqData = {
            Op: "SaveTruck",
            bint_acid: localStorage.getItem("acid"),
            bint_srno: this.state.formData.bint_srno,
            vac_truckno: this.state.formData.txttruckno.toUpperCase(),
            int_noofwheels: this.state.formData.txtNoWheels,
            vac_remark: this.state.formData.txtRemark,
          };
          console.log("Saving Truck:", reqData);
          fetchTruckDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let dataLoadStatus = true,
                rows = this.state.rows,
                rowsCount = rows.length;
              if (res.data.msgType === "success") {
                if (res.data.TruckList && res.data.TruckList.length > 0) {
                  rows = res.data.TruckList;
                  rowsCount = rows.length;
                }
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  rowsCount,
                },
                () => {
                  if (res.data.msgType === "success") {
                    this.clearInfo();
                  }
                }
              );
            })
            .catch((error) => {
              console.log("Unknown error occurred in TruckMaster.", error);
            });
        });
      }
    });
  };

  validatTruckMaster = () => {
    let result = false;
    if (
      this.state.formData.txttruckno.length <= 0 ||
      this.state.formData.txttruckno == 0
    ) {
      this.props.toastErrorMsg("Enter Truck No.", "txttruckno");
    } else if (
      this.state.formData.txtNoWheels == 0 ||
      this.state.formData.txtNoWheels == null
    ) {
      this.props.toastErrorMsg("Enter No. of Wheels.", "txtNoWheels");
    } else {
      result = true;
    }
    return result;
  };

  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "25px", color: "#6f7689" }}
            >
              <b>Truck Master</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="column"
          spacing={2}
          // marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtTxt
                  id="txttruckno"
                  value={this.state.formData.txttruckno}
                  handleOnChange={this.handleOnChange}
                  label="Truck No.*"
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtNoWheels"}
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtNoWheels"
                  value={this.state.formData.txtNoWheels}
                  handleOnChange={this.handleOnChange}
                  label="No. Wheels*"
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtRemark"}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={515}
                  maxLength={1000}
                  // onKeyDown={this.props.onKeyDown}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={1}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveTruck} />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txttruckno,
                      this.state.formData.txtNoWheels,
                      this.state.formData.txtRemark
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item marginTop={3} className="maintable">
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("TruckMaster")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={20}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(TruckMaster))));
